import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";

export class UserInfo extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(UserInfo, v) : SKIP;
            },
            (v) => {
                return deserialize(UserInfo, v);
            }
        );
    }

    constructor() {
        super();
        this._uid = null;
        this._playground = false;
        this._name = null;
        this._photo = null;
        this._created = 0;
        this._last_login = 0;
        this._audience = '';
    }

    get uid() {
        return this._uid;
    }
    set uid(value) {
        this._uid = value;
    }

    get playground() {
        return this._playground;
    }
    set playground(value) {
        this._playground = value;
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get photo() {
        return this._photo;
    }
    set photo(value) {
        this._photo = value;
    }

    get created() {
        return this._created;
    }
    set created(value) {
        this._created = value;
    }

    get last_login() {
        return this._last_login;
    }
    set last_login(value) {
        this._last_login = value;
    }

    get audience() {
        return this._audience;
    }
    set audience(value) {
        this._audience = value;
    }

    empty() {
        return this.uid == "";
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new UserInfo());
        } else if (target instanceof UserInfo) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(UserInfo, {
    _uid: alias("uid", Schema.primitive()),
    _playground: alias("playground", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _photo: alias("photo", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _last_login: alias("last_login", Schema.primitive()),
    _audience: alias("audience", Schema.primitive()),
});
